var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm',{attrs:{"title":"有効期限切れ","description":"URLの有効期限が切れています。大変お手数ですが、ログインページから再度やり直してください。","to":"login"}})}
var staticRenderFns = []

export { render, staticRenderFns }